import React, { Fragment, memo } from 'react'
import { Notification, Columns, Column } from 'Components/common/bulma'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

const NotificationItem = memo(({ uuid, message, type, onRemove }) => (
  <Notification key={uuid} success={type === 'success'} danger={type === 'danger'} className="mensaje-notificacion">
    <button className="delete" onClick={() => onRemove(uuid)}></button>
    <Columns>
      <Column className="is-3">
        {type === 'success' && (<FontAwesomeIcon icon={faCheck} size="3x"/>)}
        {type === 'danger' && (<FontAwesomeIcon icon={faTimes} size="3x"/>)}
      </Column>
      <Column>
        {message}
      </Column>
    </Columns>
  </Notification>
))

const Notificaciones = ({ notifications, onRemove }) => {
  return (
    <Fragment>
      {notifications.map((notification) => (
        <NotificationItem 
          key={notification.uuid}
          {...notification}
          onRemove={onRemove}
        />
      ))}
    </Fragment>
  );
};

export default memo(Notificaciones);